// extracted by mini-css-extract-plugin
module.exports = {"empty":"cuadrilleros_empty__3NxOT","list":"cuadrilleros_list__3SA8q","special":"cuadrilleros_special__1SC2s","li":"cuadrilleros_li__sw48U","form":"cuadrilleros_form__1Z109"};